import { LOGIN_URL } from "./urls";
export { BASE_URL } from "./urls"


export type TSTAGE = 'production' | 'development';
export let STAGE: TSTAGE = 'production';
export let FAKE_LOGIN = false;

if (window.location.href.includes("localhost") || 
    window.location.href.includes("192.168.") || 
    window.location.href.includes("platform-dev")) {
  STAGE = 'development';
}

if (window.location.href.includes("localhost") ||
    window.location.href.includes("192.168.") ||
    window.location.hostname === "app") {
  FAKE_LOGIN = true;
}


export function getLoginUrl(redirectUrl: string) {
  return `${LOGIN_URL}${redirectUrl}`
}